import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Container } from '@medely/web-components';
import { FixedTitleProps } from './interface';
import useDevice from '@mp/hooks/useDevice.web';

const FALLBACK_HEIGHT_MOBILE = 59;
const FALLBACK_HEIGHT_DESKTOP = 67;
const TITLE_CONTENT_GAP = 16;
const TOP_BAR_TEST_ID = 'topbar-root';

const useStickyHeaderHeight = (fallback: number): number => {
  const [height, setHeight] = useState<number>(fallback);

  useEffect(() => {
    const header = document.querySelector(`[data-testid="${TOP_BAR_TEST_ID}"]`);
    if (!header) {
      return;
    }
    const update = (): void => setHeight(header.getBoundingClientRect().height);
    update();
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(header);
    return () => {
      resizeObserver.disconnect();
    };
  }, [fallback]);

  return height;
};

export const FixedTitle = ({ children }: FixedTitleProps): ReactElement => {
  const isMobile = useDevice() === 'mobile';
  const headerHeight = useStickyHeaderHeight(
    isMobile ? FALLBACK_HEIGHT_MOBILE : FALLBACK_HEIGHT_DESKTOP,
  );

  return (
    <Box
      position="fixed"
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      left={isMobile ? 0 : 20}
      right={isMobile ? 0 : 20}
      top={0}
      px={2}
      pb={2}
      pt={`${headerHeight + TITLE_CONTENT_GAP}px`}
      bgcolor={'background.paper'}
      sx={{ overflowY: 'hidden' }}
      zIndex={11}
    >
      <Container maxWidth="sm">{children}</Container>
    </Box>
  );
};
